export default __webpack_public_path__ + "static/media/rug.dd2dc924.png";